import React from 'react';
import SafeImg from './SafeImg';

const IMG_BASE = { objectFit: 'cover', border: '2px solid rgb(247 247 251)' };
const GRID_BASE = { display: 'grid', gridTemplateColumns: '1fr 1fr' };

// Alturas proporcionales al ancho del card (clamp(180px,13vw,280px))
// Ratio original: imagen 1 fila = 168px sobre 244px de card = 0.688
// 1 fila:  clamp(180,13vw,280) * 0.688 ≈ clamp(124px, 9vw, 193px)
// 2 filas: mitad ≈ clamp(62px, 4.5vw, 96px)
const H1 = 'var(--card-h1, clamp(124px, 9vw, 193px))';
const H2 = 'var(--card-h2, clamp(62px, 4.5vw, 96px))';

export default function AdaptiveGrid({ ruta, imgs, thumbs, srcs: srcsProp, width = '244px' }) {
  const gridStyle = { ...GRID_BASE, width };
  let srcs;
  if (srcsProp) {
    srcs = srcsProp.filter(Boolean);
  } else {
    const display = thumbs && thumbs.length ? thumbs : imgs;
    srcs          = display.filter(Boolean).map(name => `${ruta}/${name}`);
  }
  const n = srcs.length;

  if (n === 0) return null;

  if (n === 1) return (
    <div style={gridStyle}>
      <SafeImg src={srcs[0]} loading="lazy"
        style={{ ...IMG_BASE, gridColumn: '1/3', gridRow: '1/3', width: '100%', height: H1, borderRadius: '0 0 8px 8px' }} />
    </div>
  );

  if (n === 2) return (
    <div style={gridStyle}>
      <SafeImg src={srcs[0]} loading="lazy" style={{ ...IMG_BASE, gridColumn: '1/2', gridRow: '1/3', width: '100%', height: H1, borderRadius: '0 0 0 8px' }} />
      <SafeImg src={srcs[1]} loading="lazy" style={{ ...IMG_BASE, gridColumn: '2/3', gridRow: '1/3', width: '100%', height: H1, borderRadius: '0 0 8px 0' }} />
    </div>
  );

  if (n === 3) return (
    <div style={gridStyle}>
      <SafeImg src={srcs[0]} loading="lazy" style={{ ...IMG_BASE, width: '100%', height: H2 }} />
      <SafeImg src={srcs[1]} loading="lazy" style={{ ...IMG_BASE, width: '100%', height: H2 }} />
      <SafeImg src={srcs[2]} loading="lazy"
        style={{ ...IMG_BASE, gridColumn: '1/3', width: '100%', height: H2, marginTop: '-4px', borderRadius: '0 0 8px 8px' }} />
    </div>
  );

  return (
    <div style={gridStyle}>
      <SafeImg src={srcs[0]} loading="lazy" style={{ ...IMG_BASE, width: '100%', height: H2 }} />
      <SafeImg src={srcs[1]} loading="lazy" style={{ ...IMG_BASE, width: '100%', height: H2 }} />
      <SafeImg src={srcs[2]} loading="lazy" style={{ ...IMG_BASE, width: '100%', height: H2, marginTop: '-4px', borderRadius: '0 0 0 8px' }} />
      <SafeImg src={srcs[3]} loading="lazy" style={{ ...IMG_BASE, width: '100%', height: H2, marginTop: '-4px', borderRadius: '0 0 8px 0' }} />
    </div>
  );
}
